// Thin helpers over the shared COLLABORATOR_PERMISSIONS/ROLE_PERMISSIONS tables
// (src/core/constants.js) — the permission model itself is genuinely shared
// backend-contract data, not per-app UI, so it isn't duplicated into v2.
import { COLLABORATOR_PERMISSIONS, ROLE_PERMISSIONS } from "../../core/constants.js";

export { COLLABORATOR_PERMISSIONS };

export function permissionsForRole(role) {
  return ROLE_PERMISSIONS.find((r) => r.role === role)?.permissions ?? [];
}

export function hasPermission(permissions, permission) {
  return !!permissions?.includes(permission);
}

export function hasAnyPermission(permissions, permissionList) {
  return permissionList.some((p) => hasPermission(permissions, p));
}
